/**
 * Created by pbo on 26/09/16.
 */


angular.module('taric.auth.loginhelper', ['taric.auth.model', 'taric.auth.userhelper', 'ng'])
    .factory('LoginHelper', function ($rootScope, AuthorizeModel, UserHelper, $http, $window, jwtHelper, CONSTANTS, CommonHelper) {
        var helper = {
            login: function () {           
                $http.get(`${CONSTANTS.auth_url}/token`)
                    .then(
                        response => {
                            if (!response.data.accessToken){

                                // If user did not log in earlier, then just skip getting token
                                return;
                            }
                            AuthorizeModel.jwt = response.data.accessToken;
                            $http.defaults.headers.common.Authorization = 'Bearer ' + AuthorizeModel.jwt;

                            var tokenPayload = jwtHelper.decodeToken(AuthorizeModel.jwt);
                            AuthorizeModel.loggedIn = true;
                            if (CommonHelper.removeSpaceCharacters(tokenPayload.username) !== "") {
                                AuthorizeModel.userName = tokenPayload.username;
                            } else {
                                AuthorizeModel.userName = tokenPayload.sub;
                            }

                            if (tokenPayload.roles !== "") {
                                AuthorizeModel.roles = tokenPayload.roles;
                            } else {
                                AuthorizeModel.roles = tokenPayload.sub;
                            }

                            $rootScope.$broadcast('disableLogin');
                            $rootScope.$broadcast('userName');
                    }, err => {
                        // Do nothing if can not get token
                    });
            },
            setAuthorizationHeader: function () {
                if (AuthorizeModel.loggedIn) {
                    // Set authorization header
                    $http.defaults.headers.common.Authorization = 'Bearer ' + AuthorizeModel.jwt;
                } else {
                    $http.defaults.headers.common.Authorization = null;
                }
            },
            goToLogin: function () {
                let authUri = `${CONSTANTS.auth_url}/auth?redirect_uri=${encodeURIComponent(CONSTANTS.callback_url)}`;
                $window.location.replace(authUri);
            }
        };
        return helper;
    });



// WEBPACK FOOTER //
// ./app/taric/auth/login-helper.js